import { ApiBase } from './ApiBase'

export type SiteDisplayMode = 'fixed' | 'rotating'

// a check code that hangs on site: a printed poster (fixed) or a display page whose code changes
export interface ISiteDisplay {
  id: number
  name: string
  mode: SiteDisplayMode
  team_id: number | null
  team_name: string | null
  interval_minutes: number
  active: boolean
  deactivated_at: string | null
  created_at: string
  // only for a poster, a changing code is only shown by its display page
  code: string | null
  display_url: string
  scans_count: number
  last_scanned_at: string | null
}

export interface ISiteDisplayData {
  name?: string
  mode?: SiteDisplayMode
  team_id?: number | null
  interval_minutes?: number
  active?: boolean
}

export interface ISiteDisplayCodes {
  name: string
  mode: SiteDisplayMode
  interval_minutes: number
  server_time: string
  codes: { code: string, from: string | null, until: string | null }[]
}

export interface ISiteCodeScan {
  site_display_id: number
  name: string
  team_id: number | null
  scanned_at: string
}

export class SiteCodesApi extends ApiBase {
  public async all(checklistId: number): Promise<ISiteDisplay[]> {
    const response = await this.get<ISiteDisplay[]>(`/checklists/${checklistId}/site_displays`)
    return response.data
  }

  public async create(checklistId: number, data: ISiteDisplayData): Promise<ISiteDisplay> {
    const response = await this.post<ISiteDisplay>(`/checklists/${checklistId}/site_displays`, data)
    return response.data
  }

  public async update(checklistId: number, id: number, data: ISiteDisplayData): Promise<ISiteDisplay> {
    const response = await this.put<ISiteDisplay>(`/checklists/${checklistId}/site_displays/${id}`, data)
    return response.data
  }

  public async renew(checklistId: number, id: number): Promise<ISiteDisplay> {
    const response = await this.post<ISiteDisplay>(`/checklists/${checklistId}/site_displays/${id}/renew`)
    return response.data
  }

  // the display page on site, without login
  public async display(token: string): Promise<ISiteDisplayCodes> {
    const response = await this.get<ISiteDisplayCodes>(`/site_displays/${encodeURIComponent(token)}`)
    return response.data
  }

  // the server checks the scanned code; throws with error invalid_code / too_many_attempts / closed
  public async scan(resultSetId: number, code: string, accessToken?: string | null): Promise<ISiteCodeScan | undefined> {
    const response = await this.post<ISiteCodeScan>(`/result_sets/${resultSetId}/site_code`, {
      code, access_token: accessToken || undefined
    })
    return response?.data
  }
}
